import React, { useEffect, useState } from 'react';
import './App.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { motion } from 'framer-motion';
import { FaUserMd, FaWhatsapp, FaInstagram } from 'react-icons/fa';
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';
import { FaBook } from "react-icons/fa6";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [contact, setContact] = useState({socials:{instagram:"gabrielantoniobarbosa_", whatsapp:"5519999915588"}, email:"contato@gabrielfisio.com.br", phone: "(19) 99991-5588", address: "Rua Aziz Lian, 443 - Jardim Longatto, Mogi Mirim"});

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleContactClick = (name, email, message) => {
    const emailPart = email ? `meu E-mail é ${email}` : '';
    const encodedMessage = encodeURIComponent(`Olá meu nome é ${name}, ${emailPart}\n${message}`);
    window.open('https://wa.me/'+contact.socials.whatsapp+'?text=' + encodedMessage, '_blank');
  };

  return (
    <div className="App">
      <header className="header">
        <nav>
          <motion.div
            className="logo"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            onClick={() => document.getElementById('home').scrollIntoView({ behavior: 'smooth' })}
          >
            Dr. Gabriel Barbosa
          </motion.div>
          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <motion.li whileHover={{ scale: 1.1 }}><a onClick={(e) => { e.preventDefault(); document.getElementById('sobre').scrollIntoView({ behavior: 'smooth' }); setIsMenuOpen(false); }} href="#sobre">Sobre</a></motion.li>
            <motion.li whileHover={{ scale: 1.1 }}><a onClick={(e) => { e.preventDefault(); document.getElementById('servicos').scrollIntoView({ behavior: 'smooth' }); setIsMenuOpen(false); }} href="#servicos">Serviços</a></motion.li>
            <motion.li whileHover={{ scale: 1.1 }}><a onClick={(e) => { e.preventDefault(); document.getElementById('contato').scrollIntoView({ behavior: 'smooth' }); setIsMenuOpen(false); }} href="#contato">Contato</a></motion.li>
          </ul>
          <div className={`menu-icon ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </nav>
      </header>

      <main>
        <section id="home" className="hero">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-content"
          >
            <h1>Dr. Gabriel Barbosa</h1>
            <h2>Fisioterapeuta Osteopata</h2>
            <p>Excelência em cada toque.</p>
            <motion.button
              className="cta-button"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => document.getElementById('contato').scrollIntoView({ behavior: 'smooth' })}
            >
              Entrar em contato
            </motion.button>
          </motion.div>
          <div className="hero-quote">
            <p>"Encontrar a saúde deve ser o objetivo de todo terapeuta. Qualquer um pode encontrar a doença."</p>
            <span className="quote-author">- Andrew Taylor Still</span>
          </div>
        </section>

        <section id="sobre" className="about">
          <div className="section-header" data-aos="fade-up">
            <h2>Sobre Mim</h2>
            <div className="underline"></div>
          </div>
          <div className="about-content" data-aos="fade-up">
            <div className="about-image">
              <div className="image-placeholder">
                <img src="/images/gabriel-mesa.jpg" alt="Dr. Gabriel Barbosa" style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', top: 0, left: 0 }} />
              </div>
            </div>
            <div className="about-text">
              <p style={{ textAlign: 'justify' }}>
                Com uma sólida formação em Fisioterapia e especialização em Osteopatia pela renomada Escola de Osteopatia de Madrid, me dedico a proporcionar um cuidado integral e personalizado para cada paciente. Minha expertise abrange técnicas avançadas em Osteopatia Visceral e Integração Estrutural, adquiridas através de formação especializada Belga-Espanhola, além do domínio do Método Crochetagem para tratamentos miofasciais.
              </p>
              <p style={{ textAlign: 'justify' }}>
                Acredito que cada pessoa é única e merece uma abordagem terapêutica individualizada. Meu compromisso é não apenas tratar sintomas, mas identificar e tratar a causa raiz dos desconfortos, proporcionando alívio duradouro e melhor qualidade de vida para meus pacientes.
              </p>
              <div className="experience-numbers">
                <div className="number-item" data-aos="zoom-in">
                  <span className="number">7</span>
                  <span className="label">Anos de Experiência Clínica</span>
                </div>
                <div className="number-item" data-aos="zoom-in" data-aos-delay="100">
                  <span className="number">+10000</span>
                  <span className="label">
                    <p>Atendimentos realizados.</p>
                    <p>Especialista em Tecnologia de Flexo Distração, referência mundial no tratamento de patologias da coluna.</p>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="servicos" className="services">
          <div className="section-header" data-aos="fade-up">
            <h2>Serviços</h2>
            <div className="underline"></div>
          </div>
          <div className="services-grid">
            <motion.div
              className="service-card service-fisio-osteopatica"
              data-aos="fade-up"
            >
              <FaUserMd className="service-icon" />
              <h3>Fisioterapia Osteopática</h3>
              <p><strong>Tratamento especializado para lesões musculares, articulares e dores crônicas através de técnicas manuais osteopáticas.</strong></p>
            </motion.div>
            <motion.div
              className="service-card service-cursos"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <FaBook className="service-icon" />
              <h3>Cursos</h3>
              <p><strong>Capacitação em técnicas osteopáticas para profissionais da área.</strong></p>
            </motion.div>
          </div>
        </section>

        <section id="contato" className="contact">
          <div className="section-header" data-aos="fade-up">
            <h2>Contato</h2>
            <div className="underline"></div>
          </div>
          <div className="contact-container" data-aos="fade-up">
            <div className="contact-info">
              <div className="contact-item">
                <MdLocationOn className="contact-icon" />
                <p>{contact.address}</p>
              </div>
              <div className="contact-item">
                <MdPhone className="contact-icon" />
                <p>{contact.phone}</p>
              </div>
              <div className="contact-item">
                <MdEmail className="contact-icon" />
                <p>{contact.email}</p>
              </div>
            </div>
            <form className="contact-form" onSubmit={(e) => {
              e.preventDefault();
              const formElements = e.target.elements;
              const name = formElements.name.value;
              const email = formElements.email.value;
              const message = formElements.message.value;
              handleContactClick(name, email, message);
            }}>
              <input
                type="text"
                name="name"
                placeholder="Nome"
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
              />
              <textarea
                name="message"
                placeholder="Mensagem"
                required
              ></textarea>
              <motion.button
                type="submit"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Agende sua Consulta <FaWhatsapp style={{ marginLeft: '5px' }} />
              </motion.button>
            </form>
          </div>
        </section>
      </main>

      <footer>
        <div className="footer-wave">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
          </svg>
        </div>
        <div className="footer-content">
          <div>
            <div className="footer-logo">Dr. Gabriel Barbosa</div>
            <p className="footer-about">Fisioterapeuta Osteopata dedicado a proporcionar tratamentos personalizados e eficazes para cada paciente.</p>
            <div className="footer-social">
              <a href="https://instagram.com/gabrielantoniobarbosa_" target="_blank" rel="noopener noreferrer"><FaInstagram className="social-icon" /></a>
              <a href="https://wa.me/5519999915588" target="_blank" rel="noopener noreferrer"><FaWhatsapp className="social-icon" /></a>
            </div>
          </div>

          <div className="footer-links">
            <h4>Links Rápidos</h4>
            <ul>
              <li><a onClick={() => document.getElementById('home').scrollIntoView({ behavior: 'smooth' })} href="#home">Início</a></li>
              <li><a onClick={() => document.getElementById('sobre').scrollIntoView({ behavior: 'smooth' })} href="#sobre">Sobre</a></li>
              <li><a onClick={() => document.getElementById('servicos').scrollIntoView({ behavior: 'smooth' })} href="#servicos">Serviços</a></li>
              <li><a onClick={() => document.getElementById('contato').scrollIntoView({ behavior: 'smooth' })} href="#contato">Contato</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Dr. Gabriel Barbosa - Todos os direitos reservados</p>
          <p>Excelência em cada toque.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
